import logo from "../../../assets/logo.svg";
import MenuItems from "./MenuItems";
import "./index.css";

const Sidebar = () => {
  return (
    <div className="sidebar-container h-screen flex-shrink-0 select-none surface-section flex flex-column" style={{ width: '280px' }}>
      <div className="flex align-items-center justify-content-center px-4 pt-4 pb-4 flex-shrink-0">
        <img src={logo} alt="Logo" style={{ width: '150px', height: 'auto' }} />
      </div>
      
      <div className="overflow-y-auto w-full pt-3 flex-1">
        <MenuItems />
      </div>
    </div>
  );
};

export default Sidebar;
